// extracted by mini-css-extract-plugin
export default {"customSlideMenuWrapper":"DefaultMenu__customSlideMenuWrapper--dcL","customSlideMenu":"DefaultMenu__customSlideMenu--2XT"};